<app-nav *ngIf="loggedIn()" class="d-print-none"> </app-nav>

<main>
   <div>
      <div class="container-fluid hidden-md-down" style="margin-bottom: 20px">
         <router-outlet></router-outlet>
      </div>
   </div>
</main>
